import { Grid } from '@mui/material';
import MDTypography from 'components/MDTypography';

export const SsaProfileLabel = ({ label, value }) => {
  return (
    <Grid container spacing={1} alignItems="flex-start">
      {/* Label */}
      <Grid item xs={3}>
        <MDTypography
          variant="body2"
          component="span"
          fontWeight="bold"
          textTransform="capitalize"
        >
          {label}
        </MDTypography>
      </Grid>

      {/* Value */}
      <Grid item xs={9}>
        <MDTypography
          color="text"
          variant="body2"
          component="span"
          fontWeight="regular"
        >
          : {value}
        </MDTypography>
      </Grid>
    </Grid>
  );
};

export const SsaProfileHeaderLabel = ({ label }) => {
  return (
    <MDTypography
      variant="body3"
      component="span"
      fontWeight="bold"
      textTransform="capitalize"
    >
      {label}
    </MDTypography>
  );
};
